import { FC } from "react";
import { Flex, Text } from "rebass/styled-components";

export const DiamondShape = ({ size = 6, fill = '#2ecaa5', stroke = 'black', strokeWidth = 0 }) => (
        // d={`M${cx},${cy - size} L${cx + size},${cy} L${cx},${cy + size} L${cx - size},${cy} Z`}
  <svg width={size * 2} height={size * 2} viewBox={`0 0 ${size * 2} ${size * 2}`}>
    <path
      d={`M${size},0 L${size * 2},${size} L${size},${size * 2} L0,${size} Z`}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export const TriangleShape = ({ size = 8, fill = '#2ecaa5', stroke = '#2ecaa5', strokeWidth = 0 }) => (
  <svg width={size * 2} height={size * 2} viewBox={`0 0 ${size * 2} ${size * 2}`}>
    <path
      d={`M${size},0 L0,${size * 2} L${size * 2},${size * 2} Z`}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export const CircleShape = ({ size = 6, fill = 'white', stroke = 'black', strokeWidth = 2 }) => (
  <svg
    width={size * 2}
    height={size * 2}
    viewBox={`0 0 ${size * 2} ${size * 2}`}
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx={size}
      cy={size}
      r={size - strokeWidth / 2}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);


export const CustomLegend: FC<{stroke?:string}> = ({stroke}) => (
  <Flex style={{ display: 'flex', fontSize:'13px', gap:'32px' }} justifyContent={'center'} >
    <Flex style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <CircleShape size={6} stroke={stroke} />
      <Text>Lab Only</Text>
    </Flex>
    <Flex style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <TriangleShape size={6} stroke={stroke} />
      <Text>Prescriptions Only</Text>
    </Flex>
    <Flex style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <DiamondShape size={6} stroke={stroke}/>
      <Text>Lab + Prescriptions</Text>
    </Flex>
  </Flex>
);